module.exports = __webpack_public_path__ + "img/reward.cb8c651c.svg";